import ConfigValue from '../ConfigValue/ConfigValue'
import { CONFIG_KEYS } from '../../constants'

export default function LoginFooter() {
  console.log('LoginFooter rendered')

  return (
    <div style={{ textAlign: 'right', padding: '10px' }}>
      <ConfigValue configKey={CONFIG_KEYS.loginFooterText.key} defaultValue={CONFIG_KEYS.loginFooterText.defaultValue} />
    </div>
  )
}
